/* Fairway Heat cart drawer: quantity, remove and one-tap upsells */
(function () {
  if (window.fhCartInit) return; window.fhCartInit = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function drawer() { return document.querySelector('cart-drawer'); }
  function rerender(state) {
    var d = drawer(); if (!d) { location.reload(); return; }
    var html = state.sections && state.sections['cart-drawer'];
    if (!html) { location.reload(); return; }
    var doc = new DOMParser().parseFromString(html, 'text/html'), inner = doc.querySelector('#CartDrawer');
    if (!inner || !inner.querySelector('[data-fh-cart]')) { location.reload(); return; }
    document.getElementById('CartDrawer').innerHTML = inner.innerHTML;
    var bubble = state.sections['cart-icon-bubble'], bEl = document.getElementById('cart-icon-bubble');
    if (bubble && bEl) { var bd = new DOMParser().parseFromString(bubble, 'text/html').querySelector('.shopify-section'); if (bd) bEl.innerHTML = bd.innerHTML; }
    var empty = !!document.querySelector('#CartDrawer .fh-c-empty');
    d.classList.toggle('is-empty', empty);
    var ov = document.getElementById('CartDrawer-Overlay'); if (ov) ov.addEventListener('click', function () { d.close(); });
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }
  function fail(msg) { var e = document.querySelector('[data-fh-error]'); if (e) e.textContent = msg; }
  function post(url, body, btn) {
    if (btn) btn.setAttribute('aria-busy', 'true');
    body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname;
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) btn.removeAttribute('aria-busy');
        if (!res.ok || res.j.status) { fail(res.j.description || res.j.message || 'Something went wrong. Please try again.'); return; }
        if (url.indexOf('add') > -1) {
          return fetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) { rerender({ sections: s }); });
        }
        rerender(res.j);
      })
      .catch(function () { if (btn) btn.removeAttribute('aria-busy'); fail('Could not update your cart. Please check your connection.'); });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.fh-cart [data-fh-qty]');
    if (q) { e.preventDefault(); post('cart/change.js', { line: +q.dataset.line, quantity: Math.max(0, +q.dataset.fhQty) }, q); return; }
    var v = e.target.closest('.fh-cart [data-fh-add-vest]');
    if (v) { e.preventDefault(); var sel = v.closest('.fh-c-offer').querySelector('[data-fh-size]'); post('cart/add.js', { items: [{ id: +sel.value, quantity: 1 }] }, v); return; }
    var b = e.target.closest('.fh-cart [data-fh-add-batt]');
    if (b) { e.preventDefault(); post('cart/add.js', { items: [{ id: +b.dataset.fhAddBatt, quantity: +b.dataset.qty || 1 }] }, b); }
  });
})();
/* Sale countdown in the drawer: counts to 12 AM every night (matches the page banner) */
(function () {
  if (window.fhCartTimer) return; window.fhCartTimer = true;
  function left(tz) { try { var p = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date()); var g = function (t) { var x = p.find(function (q) { return q.type === t; }); return x ? +x.value : 0; }; return 86400 - ((g('hour') % 24) * 3600 + g('minute') * 60 + g('second')); } catch (e) { return 0; } }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() { document.querySelectorAll('[data-fh-timer]').forEach(function (el) { var l = left(el.dataset.tz || 'America/Chicago'); el.querySelector('[data-h]').textContent = pad(Math.floor(l / 3600)); el.querySelector('[data-m]').textContent = pad(Math.floor(l % 3600 / 60)); el.querySelector('[data-s]').textContent = pad(l % 60); }); }
  tick(); setInterval(tick, 1000);
})();
